import { omit } from 'ramda';
import { propTypes as nxSegmentedButtonPropTypes } from '../types';
export var propTypes = omit(['isOpen', 'onToggleOpen'], nxSegmentedButtonPropTypes);
//# sourceMappingURL=types.js.map